export enum Resource {
  DELIVERY_AREAS = 'DELIVERY_AREA',
  HR_ADMINS = 'HR_ADMINS',
  BASKET_PLANS = 'BASKET_PLANS',
  USERS = 'USERS',
  ADDRESSES = 'ADDRESSES',
  BRANCHES = 'BRANCHES',
  CREDIT_CARD_PLANS = "CREDIT_CARDS"
}